import {
  RequestServiceValidationParams,
  ServiceValidationResponse,
} from "@pages/offerCreate/types";
import { api } from "../../api";
import {
  OfferResponseServices,
  RequestHistoryParams,
  OfferResponseHistory,
  RequestServicesParams,
} from "./types";

export async function requestApproveApi(id: number): Promise<void> {
  await api.post<void>(`/api/offers/${id}/request-approval`);
}

export async function offerApproveApi(id: number): Promise<void> {
  await api.post<void>(`/api/offers/${id}/approve`);
}

export async function offerRejectApi(
  id: number,
  comment: string,
): Promise<void> {
  await api.post<void>(`/api/offers/${id}/reject`, { comment });
}

export async function getOfferHistoryApi(
  id: number,
  params: RequestHistoryParams,
): Promise<OfferResponseHistory> {
  const { data } = await api.get<OfferResponseHistory>(
    `/api/offers/${id}/history`,
    { params },
  );
  return data;
}

export async function getOfferServicesApi(
  id: number,
  params: RequestServicesParams,
): Promise<OfferResponseServices> {
  const { data } = await api.get<OfferResponseServices>(
    `/api/offers/${id}/prices`,
    { params },
  );
  return data;
}

export async function validateSelectedServicesApi(
  params: RequestServiceValidationParams,
): Promise<ServiceValidationResponse> {
  const { id, items, ...filters } = params;
  const { data } = await api.post<ServiceValidationResponse>(
    `/api/offers/prices/validate`,
    { items },
    {
      params: filters,
    },
  );
  return data;
}
